module.exports = __webpack_public_path__ + "static/media/report-water-icon.b60a3c08.svg";